import styles from './ProcessCard.module.css';
import { Grid, Typography } from "@mui/material";
import SectionTitle from '../MODELS/SectionTitle/SectionTitle';
import process_image from '../../Images/About/process_example.jpg'
import SectionText from '../MODELS/SectionText/SectionText';

const ProcessCard = ({direction, text, image}) =>{

    return (
        <Grid container className={direction === 'right' ? styles.main_container_right : styles.main_container_left} mb={2}>

            {direction === 'right' && 
            <Grid container item xs={2} className={styles.line_container}>
                <div className={styles.line}></div>
            </Grid>
            }
            
            <Grid item xs={10} className={styles.process_container}>
                <Grid container itam xs={12} className={styles.process_title_container}>
                    <SectionTitle text={'process title'} color={'white'}/>
                </Grid>
                <div className={styles.process_description_container}>
                    <Grid container itam xs={12} className={styles.process_image_container}><img className={styles.process_image} src={process_image}/></Grid>
                    <Grid container itam xs={12} className={styles.process_text_container}><SectionText text={'Projektowanie biżuterii to proces kreatywny, który wymaga równowagi pomiędzy estetyką, funkcjonalnością i techniczną precyzją. Projektanci biżuterii zdolni są wyrazić swoją wizję poprzez dobór materiałów, kształtowanie formy oraz zastosowanie unikatowych zdobień. W trakcie tworzenia biżuterii, artyści często czerpią inspirację z natury, kultury czy historii, tworząc w ten sposób wyjątkowe i osobiste dzieła sztuki noszone na ciele.'} color={'white'}/></Grid>
                </div>
            
            </Grid>
            {direction === 'left' && 
            <Grid container item xs={2} className={styles.line_container}>
                <div className={styles.line}></div>
            </Grid>
            }
        </Grid>
    )
}
export default ProcessCard;